export default __webpack_public_path__ + "static/4-60dd6ac85c3d6e0c002ffc888945953b.webp";